/**
 * @ngdoc directive
 * @name customheader
 *
 * @description
 * Page header (for event page)
 */
module.directive('customheader', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '=',
            menu: '=',
            banner: '='
        },
        controller: function ($scope) {
            // add banner if defined
            if ($scope.banner) {
                $scope.cssbanner = 'url(' + $scope.banner.src + ')';
            }
        },
        template:
                '<div class="aqua-customheader" ng-style="{\'background-color\': content.field_theme_header.color_background}">' +
                '  <div class="aqua-customheader--banner" aqua-background-img="{{ cssbanner }}"></div>' +
                '  <div class="aqua-customheader--inner grid grid-bottom">' +
                '    <div class="aqua-customheader--logo grid-2">' +
                '      <img class="aqua-customheader--logo-picture" aqua-src="{{content.field_logo.src}}" alt="{{content.field_logo.alt}}">' +
                '    </div>' +
                '    <div class="aqua-customheader--brand grid-4" ng-if="content.field_teaser">' +
                '      <h1 class="aqua-customheader--brand-name" ng-style="{\'color\': content.field_theme_header.color_title}">{{content.field_teaser}}</h1>' +
                '    </div>' +
                '    <ul class="aqua-customheader--menu grid grid-bottom grid-auto grid-right" ng-class="content.field_teaser ? \'grid-6\' : \'grid-10\'" ng-style="{\'color\': content.field_theme_header.color_link}">' +
                // '      <li class="aqua-customheader--menu--item" ng-repeat="item in fMenu">' +
                '      <li class="aqua-customheader--menu--item" ng-repeat="item in content.field_links">' +
                // '        <a href="{{\'#\' + item.nid}}" class="aqua-customheader--menu--item-text">{{item.title}}</a>' +
                '        <a ng-href="{{item.uri}}" class="aqua-customheader--menu--item-text">{{item.title}}</a>' +
                '      </li>' +
                '    </div>' +
                '  </div>' +
                '</div>'
    };
});
